import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link, Route, Routes, useParams } from 'react-router-dom';
import useQueryString from '../../../utils/hooks/useQueryString';
import { UserBookNotice } from './UserBookNotice';
import { useQuery } from '@tanstack/react-query';
import Api from 'utils/api/Api';
const queryString = require('query-string');

/**
 * 나도작가다 공통상단
 * @returns 
 */
export const UserBookHeader = () => {
    const auth = useSelector(state => state.auth);
    const { school } = useParams();
    const { list, keyword, sort, creative } = useQueryString();

    const paramValue = useMemo(() => {
        const paramJson = { list: '', keyword: '', creative: "N" };
        if (list !== undefined) paramJson.list = list;
        if (keyword !== undefined) paramJson.keyword = keyword;
        if (creative !== undefined) paramJson.creative = creative;
        return paramJson;
    }, [list, keyword, creative]);

    const mySummary = useQuery({
        queryKey: ['user/book/my/summary'],
        queryFn: () => Api.get('/api/userBook/summary'),
        refetchOnMount:'always'
    });

    return (
        <div className="header">
            <div className="tabContainer">
                <ul className="tabs inner">
                    <li className={`tab ${list === undefined || list === '' ? 'active' : ''}`}><Link to={`/${school}/userbook`}>모든학교</Link></li>
                    <li className={`tab ${list === school ? 'active' : ''}`}><Link to={`/${school}/userbook?list=${school}`}>우리학교</Link></li>
                    <li className={`tab ${list === 'completed' ? 'active' : ''}`}><Link to={`/${school}/userbook?list=completed`}>완결</Link></li>
                    {auth.authenticated &&
                        <>
                            <li className={`tab ${list === 'keep' ? 'active' : ''}`}><Link to={`/${school}/userbook?list=keep&creative=all`}>찜</Link></li>
                            <li className={`tab ${list === 'my' ? 'active' : ''}`}><Link to={`/${school}/userbook?list=my&creative=all&sort=updatedAt,desc`}>내작품</Link></li>
                            <li className={`tab btnCreate ${mySummary?.data?.data?.total - mySummary?.data?.data?.complete >= 10 ? 'disabled' : ''} `} >
                                <Link to={`/${school}/userbook/create`}>만들기</Link>
                            </li>
                        </>
                    }
                </ul>
            </div>


            <Routes>
                <Route path="/" element={
                    <>
                        <div className="sorts_wrap">
                            <div className="in_sorts_wrap">
                                <div className="left-box">
                                    <div className="userbook_logo">
                                        <img src={`${process.env.PUBLIC_URL}/static/images/userbook/userbook_logo.gif`} alt="나도 작가다" />
                                    </div>
                                    <div className='search_options'>
                                        <Link className={`btn creative circleCheck ${paramValue?.creative === 'all' ? 'on' : ''}`} to={`/${school}/userbook?${queryString.stringify({ ...paramValue, page: 0, creative: paramValue?.creative === 'all' ? 'Y' : 'all' })}`}>
                                            비창작 포함
                                        </Link>
                                    </div>
                                </div>
                                {list !== 'my' &&
                                    <ul className="sorts">
                                        <li className={`${undefined === sort || sort === 'updatedAt,desc' ? 'active' : ''}`}>
                                            <Link to={`/${school}/userbook?sort=updatedAt,desc&${queryString.stringify(paramValue)}`}>최신순</Link>
                                        </li>
                                        <li className={`${sort === 'readCount,desc' ? 'active' : ''}`}>
                                            <Link to={`/${school}/userbook?sort=readCount,desc&${queryString.stringify(paramValue)}`}>조회순</Link>
                                        </li>
                                        <li className={`${sort === 'commentCount,desc' ? 'active' : ''}`}>
                                            <Link to={`/${school}/userbook?sort=commentCount,desc&${queryString.stringify(paramValue)}`}>댓글순</Link>
                                        </li>
                                        <li className={`${sort === 'likeCount,desc' ? 'active' : ''}`}>
                                            <Link to={`/${school}/userbook?sort=likeCount,desc&${queryString.stringify(paramValue)}`}>좋아요순</Link>
                                        </li>
                                    </ul>
                                }
                            </div>
                        </div>
                        <UserBookNotice />
                        {list === 'my' &&
                            <div className="bookSummary">
                                <span className='separate'>연재 <strong>{mySummary?.data?.data?.total - mySummary?.data?.data?.complete || 0}</strong></span>
                                <span>완결 <strong>{mySummary?.data?.data?.complete || 0}</strong></span>
                                {/* <span className='total'><strong>{mySummary?.data?.data?.total || 0}</strong></span> */}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <span className='separate'>창작 <strong>{mySummary?.data?.data?.creative || 0}</strong></span>
                                <span>비창작 <strong>{mySummary?.data?.data?.total - mySummary?.data?.data?.creative || 0}</strong></span>
                            </div>

                        }
                    </>
                }
                />
            </Routes>
        </div>
    );
}


